import axios from '@/services/axios';

const BASE_PATH =
  '/financeiro/cobrancas';

function cleanParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params)
      .filter(([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== ''
      )
  );
}

async function listar(
  params = {}
) {
  const response =
    await axios.get(
      BASE_PATH,
      {
        params:
          cleanParams(params)
      }
    );

  const data =
    response.data;

  return {
    data:
      Array.isArray(data?.data)
        ? data.data
        : [],

    paginacao: {
      pagina:
        Number(
          data?.paginacao?.pagina ??
          1
        ),

      limite:
        Number(
          data?.paginacao?.limite ??
          20
        ),

      total_itens:
        Number(
          data?.paginacao
            ?.total_itens ??
          0
        ),

      total_paginas:
        Number(
          data?.paginacao
            ?.total_paginas ??
          0
        )
    }
  };
}

function normalizeId(id) {
  const normalizedId =
    Number(id);

  if (
    !Number.isSafeInteger(
      normalizedId
    ) ||
    normalizedId <= 0
  ) {
    throw new TypeError(
      'ID da cobrança inválido.'
    );
  }

  return normalizedId;
}

async function detalhar(id) {
  const normalizedId =
    normalizeId(id);

  const response =
    await axios.get(
      `${BASE_PATH}/${normalizedId}`
    );

  return response.data;
}

async function registrar(id) {
  const normalizedId =
    normalizeId(id);

  const response =
    await axios.post(
      `${BASE_PATH}/${normalizedId}/registrar`,
      {}
    );

  return response.data;
}

async function cancelar(id) {
  const normalizedId =
    normalizeId(id);

  const response =
    await axios.post(
      `${BASE_PATH}/${normalizedId}/cancelar`,
      {}
    );

  return response.data;
}

async function obterPreviewEmail(id) {
  const normalizedId =
    normalizeId(id);

  const response =
    await axios.get(
      `${BASE_PATH}/${normalizedId}/email/preview`
    );

  return response.data;
}

async function enviarEmail(id) {
  const normalizedId =
    normalizeId(id);

  const response =
    await axios.post(
      `${BASE_PATH}/${normalizedId}/email/enviar`,
      {}
    );

  return response.data;
}

async function obterResumoJobs() {
  const response =
    await axios.get(
      `${BASE_PATH}/jobs/resumo`
    );

  return response.data;
}


async function listarProblemasJobs(
  params = {}
) {
  const response =
    await axios.get(
      `${BASE_PATH}/jobs/problemas`,
      {
        params:
          cleanParams(
            params
          )
      }
    );

  return response.data;
}


async function consultarReemissao(id) {
  return (await axios.get(`${BASE_PATH}/${normalizeId(id)}/reemissao`)).data;
}

async function reemitir(id, dados) {
  return (await axios.post(`${BASE_PATH}/${normalizeId(id)}/reemitir`, dados)).data;
}

export const cobrancasApi = {
  async capturarBeneficiario(id) { return (await axios.post(`${BASE_PATH}/${id}/capturar-beneficiario`, { conferido: true })).data; },
  consultarReemissao,
  reemitir,
  listar,
  detalhar,
  registrar,
  cancelar,
  obterPreviewEmail,
  enviarEmail,
  obterResumoJobs,
  listarProblemasJobs
};

export default cobrancasApi;
